export interface WebHookClass{
    AccountWebhookSubscriptionID:string,
    AccountId:number,
    AccountEmployeeID:number,
    TargetURL:string,
    IsActive:boolean,
    FormId:number,
    SystemWebHookEventTypeID:string,
    SystemWebHookSourceId:string,
    WebHookName:string,
    isSelected:number
}
export interface WebHookEventTypesClass{
    GroupName: string;
    Items: {SystemWebHookEventTypeID: string,SystemWebHookEventName:string,SystemWebhookEventTypeCaption:string,Checked:boolean}[];
}

export interface WebHookSubscriptionWithDetail{
    AccountWebhookSubscriptionID:string,
    SystemWebHookSourceId:string,
    WebHookName:string,
    TargetURL:string,
    IsActive:boolean,
    WebHookEntries:{SystemWebHookEventTypeId:string,WebHookEventName:string,Stat:boolean} []
}


const common = {    
    AccountWebhookSubscriptionID:"00000000-0000-0000-0000-000000000000",
    SystemWebHookSourceId:"00000000-0000-0000-0000-000000000000",
    WebHookName:"",
    TargetURL:"",
    IsActive:true,
    WebHookEntries:[]
  };
  
  export const WebHookSubscriptionWithDetailInitialsForAdd = { ...common };
  
  export const WebHookSubscriptionWithDetailInitialsForUpdate = { ...common };
  
// export const WebHookSubscriptionWithDetailInitialsForAdd ={
    
//     AccountWebhookSubscriptionID:"00000000-0000-0000-0000-000000000000",
//     SystemWebHookSourceId:"00000000-0000-0000-0000-000000000000",
//     WebHookName:"",
//     TargetURL:"",
//     IsActive:true,
//     WebHookEntries:[]
// }
// export const WebHookSubscriptionWithDetailInitialsForUpdate ={
    
//     AccountWebhookSubscriptionID:"00000000-0000-0000-0000-000000000000",
//     SystemWebHookSourceId:"00000000-0000-0000-0000-000000000000",
//     WebHookName:"",
//     TargetURL:"",
//     IsActive:true,
//     WebHookEntries:[]
// }
